import { KanbanTaskCardController } from './kanban-task-card.controller'

function kanbanTaskCard () {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      task: '<',
      column: '<',
      openDetails: '&',
      workingDays: '<'
    },
    templateUrl: '/workflow/directives/kanban-task-card/kanban-task-card-directive.html?$$REVISION$$',
    controller: KanbanTaskCardController
  }
}

export { kanbanTaskCard }
